import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { ImportManagerComponent } from './import-manager.component';
import { AuthGuard } from 'shared/auth/auth.guard';
import { SubscriptionGuard } from 'shared/subscription/subscription.guard';
import { PermissionsResolver } from 'shared/permissions/permissions.resolver';
import { PermissionsGuard } from 'shared/permissions/permissions.guard';


@NgModule({
  imports: [
    RouterModule.forChild([
      {
        path: 'import-manager',
        component: ImportManagerComponent,
        canActivate: [AuthGuard, SubscriptionGuard, PermissionsGuard],
        data: { permissions: ['admin', 'catalog-edit'] },
        resolve: { permissions: PermissionsResolver }
      },
    ])
  ],
  exports: [RouterModule],
})
export class ImportManagerRoutingModule { }
